import { unref } from "vue";
import commaNumber from "comma-number";

export function isValidDate(d) {
    if (!/^\d?\d\/\d?\d\/\d\d\d\d$/.test(d)) {
        return false
    }
    const s = d.split('-')
    const month = parseInt(s[0])
    const day = parseInt(s[1])
    const year = parseInt(s[2])
    let monthLengths = [31,28,31,30,31,30,31,31,30,31,30,31]
    if (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0)) {
        monthLengths[1] = 29
    }
    if (month < 1 || month > 12) {
        return false
    }
    if (day < 1 || day > monthLengths[month - 1]) {
        return false
    }
    return true
}

function formatDate(v) {
    if (!v || typeof v !== 'string') {
        return v
    }
    const s = v.replace(/Z?$/, '').split('T')
    const start = s[0]
    const end = s[1]
    const ss = start.split('-')
    if (ss.length === 3) {
        try {
            return new Date(parseInt(ss[0]), parseInt(ss[1]) - 1, parseInt(ss[2])).toLocaleDateString()
        }
        catch (e) {
            return v
        }
    }
    return v
}

export function decodeUser(u, roles = []) {
    const o = {}
    o.id = u?.id
    o.auth0Id = u?.auth0_user_id
    o.blocked = u?.blocked
    o.platformAccountId = u?.cephisso_platform_accounts_id
    o.name = (u?.first_name ?? '') + ' ' + (u?.last_name ?? '')
    o.email = u?.email
    o.roles = roles
    return o
}

export function decodeUserGroupMembership(gm) {
    const o = {}
    o.id = gm.id
    o.userId = gm?.cephisso_platform_users_id
    o.groupId = gm?.cephisso_platform_user_groups_id
    o.platformAccountId = gm?.cephisso_platform_accounts_id
    return o
}

export function decodeUserGroup(ug) {
    const o = {}
    o.id = ug.id
    o.platformAccountId = ug?.cephisso_platform_accounts_id
    o.name = ug?.name
    return o
}

export function decodeAccount(a) {
    const o = {}
    o.id = a?.id
    o.name = a?.account_name
    o.parentId = a?.cephisso_platform_accounts_id
    o.created = a.created_on ? a.created_on : 0
    o.whitelabel = a?.metadata?.sustain?.whitelabel
    return o
}

export function decodeKnowledgeSourceType(kst) {
    const o = {}
    o.id = kst.id
    o.platformAccountId = kst?.cephisso_platform_accounts_id
    o.name = kst?.title
    o.machineName = kst?.machine_name
    return o
}

export function decodeKnowledgeSource(ks) {
    const o = {}
    o.id = ks.id
    o.platformAccountId = ks?.cephisso_platform_accounts_id
    o.name = ks?.title
    o.metadata = ks?.metadata
    o.description = ks?.description
    o.knowledgeSourceType = ks?.knowledge_source_types_id
    o.hasCredentials = !!ks?.has_credentials
    return o
}

export function decodeModel(m) {
    const o = {}
    o.id = m.id
    o.platformAccountId = m?.cephisso_platform_accounts_id
    o.name = m?.model_name
    o.machineName = m?.model_machine_name
    o.provider = m?.model_provider
    o.tokenLimit = m?.token_limit
    o.tokenSoftLimit = m?.token_soft_limit
    o.tokenRagSoftLimit = m?.token_rag_soft_limit
    return o
}

export function decodeModelDeployment(md, modelsRef, modelCredentialsRef) {
    const o = {}
    o.id = md.id
    o.platformAccountId = md?.cephisso_platform_accounts_id
    o.name = md?.name
    o.status = md?.status
    o.deploymentDate = md?.deployment_date
    try {
        o.deploymentDate = formatDate(o.deploymentDate)
    }
    catch (e) {
    }
    o.discontinuedDate = md?.discontinued_date
    try {
        o.discontinuedDate = formatDate(o.discontinuedDate)
    }
    catch (e) {
    }
    o.llmModelsId = md?.llm_models_id
    o.credentialsId = md?.ai_model_deployment_credentials_id
    o.machineName = md?.machine_name
    o.metadata = md?.metadata

    o.modelId = md?.llm_models_id
    o.modelName = null
    o.modelProvider = null
    if (o.modelId) {
        for (let j = 0; j < unref(modelsRef)?.length; j++) {
            if (String(unref(modelsRef)[j].id) === String(o.modelId)) {
                o.modelName = unref(modelsRef)[j].name
                o.modelProvider = unref(modelsRef)[j].provider
                break
            }
        }
    }

    if (o.credentialsId) {
        for (let j = 0; j < unref(modelCredentialsRef)?.length; j++) {
            if (String(unref(modelCredentialsRef)[j].id) === String(o.credentialsId)) {
                o.credentialsAuthHeaderName = unref(modelCredentialsRef)[j].metadata?.authHeader
                o.credentialsAnthropicVersion = unref(modelCredentialsRef)[j].metadata?.anthropicVersion
                break
            }
        }
    }

    return o
}

export function decodeModelDeploymentCredential(mdc) {
    const o = {}
    o.id = mdc.id
    o.platformAccountId = mdc?.cephisso_platform_accounts_id
    o.name = mdc?.title
    o.metadata = mdc?.metadata
    o.hasCredentials = mdc?.has_credentials
    return o
}

export function decodeLlmQuota(q) {
    const o = {}
    o.id = q.id
    o.platformAccountId = q?.cephisso_platform_accounts_id
    o.name = q?.name
    o.dailyQuota = commaNumber(q?.daily_credit_quota)
    o.monthlyQuota = commaNumber(q?.monthly_credit_quota)
    return o
}

export function decodeLlmQuotaAssignment(qa) {
    const o = {}
    o.id = qa.id
    o.platformAccountId = qa?.cephisso_platform_accounts_id
    o.name = qa?.name
    o.llmQuotaId = qa?.ai_credit_quotas_id
    o.userId = qa?.cephisso_platform_users_id
    o.groupId = qa?.cephisso_platform_user_groups_id
    return o
}

export function decodeSkill(s) {
    const o = {}
    o.id = s.id
    o.platformAccountId = s?.cephisso_platform_accounts_id
    o.name = s?.name
    o.shortDescription = s?.short_description
    o.longDescription = s?.long_description
    o.machineName = s?.machine_name
    o.messageToUser = s?.message_to_user
    o.organizational = !!s?.organizational
    o.output = s?.output
    o.version = s?.version
    o.metadata = s?.metadata
    return o
}

export function decodeSkillStepType(sst) {
    const o = {}
    o.id = sst.id
    o.platformAccountId = sst?.cephisso_platform_accounts_id
    o.name = sst?.title
    o.machineName = sst?.machine_name
    o.description = sst?.description
    return o
}

export function decodeSkillStep(ss) {
    const o = {}
    o.id = ss.id
    o.platformAccountId = ss?.cephisso_platform_accounts_id
    o.name = ss?.title
    o.machineName = ss?.machine_name
    o.skillId = ss?.ai_skills_id
    o.stepId = ss?.ai_skill_steps_id
    o.stepOrder = ss?.step_order
    o.typeId = ss?.ai_skill_step_types_id
    o.description = ss?.description
    o.userMessage = ss?.user_message
    o.systemMessage = ss?.system_message
    o.disableModes = ss?.disable_modes
    o.inputVariables = ss?.input_variables
    if (ss?.ai_skill_id_to_execute_id) {
        o.aiSkillToExecuteId = ss?.ai_skill_id_to_execute_id
    }
    else {
        o.aiSkillToExecuteId = ss?.ai_skill_to_execute_id
    }
    return o
}

export function decodeSkillAccessGrant(sa) {
    const o = {}
    o.id = sa.id
    o.platformAccountId = sa?.cephisso_platform_accounts_id
    o.skillId = sa?.ai_skills_id
    o.userId = sa?.cephisso_platform_users_id
    o.groupId = sa?.cephisso_platform_user_groups_id
    return o
}

export function decodeAiBotAccessGrant(sa) {
    const o = {}
    o.id = sa.id
    o.platformAccountId = sa?.cephisso_platform_accounts_id
    o.botId = sa?.ai_bots_id
    o.userId = sa?.cephisso_platform_users_id
    o.groupId = sa?.cephisso_platform_user_groups_id
    return o
}

export function decodeLlmModelDeploymentAccess(da) {
    const o = {}
    o.id = da.id
    o.platformAccountId = da?.cephisso_platform_accounts_id
    o.llmModelDeploymentId = da?.llm_model_deployments_id
    o.userId = da?.cephisso_platform_users_id
    o.groupId = da?.cephisso_platform_user_groups_id
    return o
}

export function decodeSkillGrouping(sg) {
    const o = {}
    o.id = sg.id
    o.platformAccountId = sg?.cephisso_platform_accounts_id
    o.title = sg?.title
    o.machineName = sg?.machine_name
    o.groupingOrder = sg?.grouping_order
    return o
}

export function decodeSkillGroupingAssignment(sga) {
    const o = {}
    o.id = sga.id
    o.platformAccountId = sga?.cephisso_platform_accounts_id
    o.skillId = sga?.ai_skills_id
    o.groupingId = sga?.ai_skill_groupings_id
    return o
}

/**
 * Parse a vector source string (same format as Skills.vue Vector Query step).
 * Returns { type, fileIndex, fileIds, directoryIds, knowledgeSourceIds }.
 */
export function parseVectorSource(vectorSource) {
    if (!vectorSource || String(vectorSource).trim() === '') {
        return { type: 'all', fileIndex: 0, fileIds: [], directoryIds: [], knowledgeSourceIds: [] }
    }
    const str = String(vectorSource).trim()
    if (str === 'all') return { type: 'all', fileIndex: 0, fileIds: [], directoryIds: [], knowledgeSourceIds: [] }
    if (str === 'input_files') return { type: 'input_files', fileIndex: 0, fileIds: [], directoryIds: [], knowledgeSourceIds: [] }
    const inputFileMatch = str.match(/^input_file\[(\d+)\]$/)
    if (inputFileMatch) {
        return { type: 'input_file_index', fileIndex: parseInt(inputFileMatch[1], 10), fileIds: [], directoryIds: [], knowledgeSourceIds: [] }
    }
    if (str.startsWith('directory_id:')) {
        const ids = str.substring('directory_id:'.length).trim().split(',')
            .map(id => {
                const trimmed = String(id).trim()
                const parsed = parseInt(trimmed, 10)
                return isNaN(parsed) ? trimmed : parsed
            })
            .filter(id => id !== '' && id !== null && id !== undefined)
        return { type: 'directories', fileIndex: 0, fileIds: [], directoryIds: ids, knowledgeSourceIds: [] }
    }
    if (str.startsWith('knowledge_source_id:')) {
        const ids = str.substring('knowledge_source_id:'.length).trim().split(',')
            .map(id => parseInt(String(id).trim(), 10))
            .filter(id => !isNaN(id))
        return { type: 'knowledge_sources', fileIndex: 0, fileIds: [], directoryIds: [], knowledgeSourceIds: ids }
    }
    const ids = str.split(',')
        .map(id => {
            const trimmed = String(id).trim()
            const parsed = parseInt(trimmed, 10)
            return isNaN(parsed) ? trimmed : parsed
        })
        .filter(id => id !== '' && id !== null && id !== undefined)
    return { type: 'files', fileIndex: 0, fileIds: ids, directoryIds: [], knowledgeSourceIds: [] }
}

export function decodeAiBot(b) {
    const o = {}
    o.id = b.id
    o.platformAccountId = b?.cephisso_platform_accounts_id
    o.title = b?.title
    o.userId = b?.cephisso_platform_users_id || null
    o.userGroupId = b?.cephisso_platform_user_groups_id || null

    let parsed = {}
    try {
        const raw = b?.metadata
        if (typeof raw === 'string') {
            parsed = raw ? JSON.parse(raw) : {}
        } else if (raw && typeof raw === 'object') {
            parsed = { ...raw }
        }
    } catch (_) {
        parsed = {}
    }
    o.metadata = parsed

    o.webSearchEnabled = o.metadata?.webSearchEnabled ?? false
    const internalKnowledge = o.metadata?.internalKnowledge
    const validModes = ['all', 'select', 'none']
    o.internalKnowledgeMode = validModes.includes(internalKnowledge) ? internalKnowledge : 'none'
    o.internalKnowledgeVectorSource = o.metadata?.internalKnowledgeVectorSource ?? null

    if (o.metadata?.internalKnowledge === 'select' && o.metadata?.internalKnowledgeVectorSource) {
        const parsedVec = parseVectorSource(o.metadata.internalKnowledgeVectorSource)
        o.knowledgeSourceIds = parsedVec.knowledgeSourceIds || []
    } else {
        o.knowledgeSourceIds = []
    }

    return o
}

export function decodeAiBotSkillAssignment(a) {
    const o = {}
    o.id = a.id
    o.aiBotId = a?.ai_bots_id
    o.skillId = a?.ai_skills_id
    return o
}